import { CrmExportFormat } from "types/Models/crmFields";

/** URL query param isn't persisted for export (unlike crm_filters) - the export modal's choices
 * are one-shot per click, not part of the shareable list URL. */
export const CRM_EXPORT_FORMAT: Record<string, CrmExportFormat> = {
  XLSX: "xlsx",
  CSV: "csv",
};

export const CRM_EXPORT_FORMAT_OPTIONS = [
  { value: CRM_EXPORT_FORMAT.XLSX, label: "Excel (.xlsx)" },
  { value: CRM_EXPORT_FORMAT.CSV, label: "CSV" },
];

/** Above this many matching rows, the modal asks the user to confirm before generating the
 * file - a deliberate pause before a very large export rather than a silent slow download. */
export const LARGE_EXPORT_ROW_WARNING_THRESHOLD = 1000;
